import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "sentToEvent";
const initialState = {
  sentToEvent: [],
  loading: false,
  error: null,
};

export const sentToEventAPI = createAsyncThunk(
  "sentToEvent",
  async ({ search, skip, limit, id }) => {
    var formData = {};

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }event/get-send-interests/?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const sentToEventSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sentToEventAPI.pending, (state) => {
      state.sentToEvent = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sentToEventAPI.fulfilled, (state, action) => {
      state.sentToEvent = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(sentToEventAPI.rejected, (state, action) => {
      state.sentToEvent = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default sentToEventSlice.reducer;
